import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { useDoctorsByClinicId } from '@/hooks/useDoctorsByClinicId'
import { Skeleton } from '@/components/ui/skeleton'
import { useViewMode } from '@/stores/viewMode'
import { DataTable } from './data-table'
import { DoctorDialog } from './DoctorDialog'
import { columns } from './columns'

export default function DoctorsPage() {
  const { id: clinicId } = useViewMode()

  const [showAddDialog, setShowAddDialog] = useState(false)
  const [searchName, setSearchName] = useState('')

  const { doctors, isLoading, isError, mutate } = useDoctorsByClinicId(clinicId?.toString())

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入醫生列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  // Filter doctors by name if search is active
  const filteredDoctors = searchName
    ? doctors.filter((doctor) => doctor.name.toLowerCase().includes(searchName.toLowerCase()))
    : doctors

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">醫生管理</h2>
          <p className="text-muted-foreground mt-2">管理診所醫生資訊</p>
        </div>
        <Button onClick={() => setShowAddDialog(true)}>
          <Plus className="mr-2 h-4 w-4" />
          新增醫生
        </Button>
      </div>

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={filteredDoctors || []}
            onSearch={setSearchName}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      <DoctorDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        clinicId={Number(clinicId)}
        onSuccess={() => mutate()}
      />
    </div>
  )
}
